// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_content_delivery_bucket": "latform-20191214193402-hostingbucket-production",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://dws0zq042lsu0.cloudfront.net",
    "aws_cognito_identity_pool_id": "us-east-1:e0a10f72-99cf-4bc4-be78-b436131104c5",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_mQJZMzk3T",
    "aws_user_pools_web_client_id": "6gka8bl49mrau636uqff820u63",
    "oauth": {
        "domain": "platform4c2f8cd9-4c2f8cd9-production.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://account.corsava.com/",
        "redirectSignOut": "https://account.corsava.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "CorsavaMetrics",
            "endpoint": "https://8hvgy8kglj.execute-api.us-east-1.amazonaws.com/production",
            "region": "us-east-1"
        },
        {
            "name": "InternalMetrics",
            "endpoint": "https://0d2pg5ka1f.execute-api.us-east-1.amazonaws.com/production",
            "region": "us-east-1"
        },
        {
            "name": "UserMigration",
            "endpoint": "https://iil0rrees7.execute-api.us-east-1.amazonaws.com/production",
            "region": "us-east-1"
        },
        {
            "name": "VPCStat",
            "endpoint": "https://a8zdi99hud.execute-api.us-east-1.amazonaws.com/production",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
